<template>
    <div class="reading-report">
        <section class="report__overview">
            <div class="overview__info">
                <span class="info__grade">{{ kreadData.currentKread?.studentGradeName }}</span>
                <p class="info__title">{{ kreadData.currentKread?.studentName }}님의 <strong>KReaD 독해력 분석리포트</strong></p>
                <span class="info__lesson">{{ kreadData.currentKread?.kreadReportRangeNm }}</span>
                <span class="info__grade" style="margin-top: 30px"><q-icon name="img:/assets/images/icon/ico_report_calender.svg" style="width: 2.1vw; height: 2.1vw" />{{ moment(kreadData.currentKread?.createTs).format('YYYY.MM.DD') }}</span>
            </div>
        </section>
        <section class="report__section analyze-result">
            <h3 class="report__section__title">독해력 분석 결과</h3>
            <div class="analyze-result__data">
                <dl class="data__list">
                    <dt class="data__title">독해력 성취율<button type="button" class="btn__view-detail">?</button></dt>
                    <dd class="data">
                        <span class="emphasis">{{ kreadData.currentKread?.accuracyRate }}%</span>/100%
                    </dd>
                    <dd class="data__past">
                        <span class="data__past__title">과거의 나</span>
                        {{ kreadData.beforeKread?.accuracyRate }}%
                        <span class="data__dim">/100%</span>
                    </dd>
                </dl>
                <dl class="data__list">
                    <dt class="data__title">학습자 위치</dt>
                    <dd class="data">
                        <span class="emphasis">상위 {{ kreadData.currentKread?.studentRankingRate }}%</span>
                    </dd>
                    <dd class="data__past">
                        <span class="data__past__title">과거의 나</span>
                        <span v-if="kreadData.beforeKread?.kreadReportRangeSeq !== 1">{{ kreadData.beforeKread?.studentRankingRate }}%</span>
                        <span v-else> - </span>
                    </dd>
                </dl>
                <dl class="data__list">
                    <dt class="data__title">총 학습 기간</dt>
                    <dd class="data">
                        <span class="emphasis"> {{ kreadData.currentKread?.learningDay }}일 소요</span>
                    </dd>
                    <dd class="data__desc">180일 권장</dd>
                </dl>
                <dl class="data__list">
                    <dt class="data__title">학습한 지문 / 문항 수</dt>
                    <dd class="data">
                        <span class="emphasis">{{ kreadData.currentKread?.learningPassageCount }}지문<br />/ {{ kreadData.currentKread?.learningProblemCount }}문항</span>
                    </dd>
                </dl>
                <dl class="data__list">
                    <dt class="data__title">다음 학습 진도</dt>
                    <dd class="data">
                        <span class="emphasis">{{ kreadData.currentKread?.nextLearningLesson }}</span>
                    </dd>
                    <!-- 데이터에 따라 바인딩 처리 필요 이동 -->
                    <dd class="data__desc">{{ nextKreadRange }}</dd>
                </dl>
            </div>
            <div class="analyze-result__chart">
                <LineChart v-if="kreadData && kreadTotalChartData" :chartData="kreadTotalChartData" :key="kreadTotalChartData.length" :chartTitle="'kread'" height="25vw" width="100%" />
            </div>
            <p class="analyze-result__text">
                {{ commentData.sbReportOverall }}
            </p>
        </section>

        <section class="report__section kread-reading">
            <h3 class="report__section__title">KReaD 지문 분석</h3>
            <p class="kread-reading__text">
                {{ commentData.sbSubSubject }}
            </p>
            <div class="kread-reading__graph__wrap">
                <span class="kread-reading__graph__title">지문 평균 KReaD</span>
                <div class="col">
                    <KreadChart v-if="kreadData.currentKread?.kreadAvg" :value="kreadData.currentKread?.kreadAvg" :height="2" />
                </div>
            </div>
            <!-- 문학 -->
            <table class="kread-reading__table">
                <thead>
                    <tr>
                        <th class="text-center">학습 영역</th>
                        <th class="text-center">총 학습 지문 수</th>
                        <th class="text-center">갈래</th>
                        <th class="text-center">학습 지문수</th>
                        <th class="text-center">평균 학습 시간</th>
                    </tr>
                </thead>
                <tbody v-if="splitTableData.litherature">
                    <tr v-for="(passage, index) in splitTableData.litherature" :Key="passage.kreadReportSplitSeq">
                        <td v-if="index % 5 === 0" :rowspan="index % 5 === 0 ? 5 : 1">문학</td>
                        <td v-if="index % 5 === 0" :rowspan="index % 5 === 0 ? 5 : 1">96</td>

                        <td>{{ passage.splitName }}</td>
                        <td>{{ passage.splitCount }}</td>
                        <td>
                            {{ getTimeStringSecondsKor(passage.learningTime / 1000) }}
                        </td>
                    </tr>
                </tbody>
            </table>

            <!-- 비문학 -->
            <table class="kread-reading__table">
                <thead>
                    <tr>
                        <th class="text-center">학습 영역</th>
                        <th class="text-center">총 학습 지문 수</th>
                        <th class="text-center">주제</th>
                        <th class="text-center">학습 지문수</th>
                        <th class="text-center">평균 학습 시간</th>
                    </tr>
                </thead>
                <tbody v-if="splitTableData.nonLiterature">
                    <tr v-for="(passage, index) in splitTableData.nonLiterature" :Key="passage.kreadReportSplitSeq">
                        <td v-if="index % 7 === 0" :rowspan="index % 7 === 0 ? 7 : 1">비문학</td>
                        <td v-if="index % 7 === 0" :rowspan="index % 7 === 0 ? 7 : 1">96</td>

                        <td>{{ passage.splitName }}</td>
                        <td>{{ passage.splitCount }}</td>
                        <td>
                            {{ getTimeStringSecondsKor(passage.learningTime / 1000) }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </section>

        <section class="report__section kread-detail">
            <h3 class="report__section__title">KReaD 독해력 상세 분석</h3>
            <section class="kread-detail__part type1">
                <h4 class="part__title">갈래/주제별 분석</h4>
                <p class="part__desc">
                    {{ commentData.sbReportSplitSubject }}
                </p>
                <div class="contents__wrap">
                    <div class="contents" v-for="achievement in Object.values(splitTableData)" :Key="achievement.kreadReportSplitSeq">
                        <span class="contents__title">{{ achievement[0]?.areaCode == '01' ? '문학' : '비문학' }}</span>
                        <ul class="contents__data">
                            <div class="data__label"><span>이번 성취율</span><span>이전 성취율</span></div>
                            <li
                                class="data__list"
                                :class="[
                                    'strength__list',
                                    {
                                        strength__list__warning: list.accuracyRate < 50,
                                    },
                                    { emphasis: index <= 2 && list.accuracyRate !== 0 },
                                ]"
                                v-for="(list, index) in achievement"
                                :key="`list_${index}`"
                            >
                                <label class="data__title" :for="list.splitName">
                                    {{ list.splitName }}
                                </label>
                                <div class="data">
                                    <div class="progress__wrap">
                                        <progress class="progress__average" :id="list.splitName" max="100" :value="list.accuracyRate"></progress>
                                        <progress class="progress__before-average" :id="list.splitName" max="100" :value="list.beforeAccuracyRate"></progress>
                                    </div>
                                    <span class="progress__label">{{ list.accuracyRate }}%</span>
                                    <span class="progress__label">{{ list.beforeAccuracyRate ? list.beforeAccuracyRate : 0 }}%</span>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </section>
            <section class="kread-detail__part type2">
                <h4 class="part__title">
                    학습 개념별 분석
                    <button type="button" class="btn__view-detail">?</button>
                </h4>
                <p class="part__desc">
                    {{ commentData.sbReportForder03 }}
                </p>
                <div class="contents">
                    <span class="contents__title">문학</span>
                    <table class="kread-detail__table">
                        <thead>
                            <tr>
                                <th>학습 개념</th>
                                <th style="text-align: left">학습 개념 상세</th>
                                <th>정답률</th>
                            </tr>
                        </thead>
                        <tbody v-if="literConcept">
                            <tr v-for="data in literConcept" :Key="data.kreadReportFolder03Seq">
                                <td v-if="data.gubunRow == 1" :rowspan="data.gubunCount">{{ data.gubunName }}</td>
                                <td style="text-align: left">{{ data.folderNm03 }}</td>
                                <td class="emphasis">{{ data.folder03Rate }}%</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="contents">
                    <span class="contents__title">비문학</span>
                    <table class="kread-detail__table">
                        <thead>
                            <tr>
                                <th>학습 개념</th>
                                <th style="text-align: left">학습 개념 상세</th>
                                <th>정답률</th>
                            </tr>
                        </thead>
                        <tbody v-if="nonliterConcept">
                            <tr v-for="data in nonliterConcept" :Key="data.kreadReportFolder03Seq">
                                <td>{{ data.gubunName }}</td>
                                <td style="text-align: left">{{ data.folderNm03 }}</td>
                                <td class="emphasis">{{ data.folder03Rate }}%</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </section>
            <section class="kread-detail__part type3">
                <h4 class="part__title">
                    지문 읽기 및 이해 활동
                    <button type="button" class="btn__view-detail">?</button>
                </h4>
                <p class="part__desc">
                    {{ commentData.sbReportReadTime }}
                </p>
                <div class="contents">
                    <span class="contents__title">문학</span>
                    <table class="kread-detail__table">
                        <thead>
                            <tr>
                                <th style="text-align: left">갈래</th>
                                <th>권장시간 준수</th>
                                <th>권장시간 초과</th>
                                <th>주의</th>
                            </tr>
                        </thead>
                        <tbody v-if="splitTableData.litherature">
                            <tr v-for="data in splitTableData.litherature" :Key="data.kreadReportSplitSeq">
                                <td style="text-align: left">{{ data.splitName }}</td>
                                <td>{{ data.readTimeOkRate }}%</td>
                                <td>{{ data.readTimeOverRate }}%</td>
                                <td>{{ data.readTimeWarnRate }}%</td>
                            </tr>
                            <tr class="total">
                                <td style="text-align: left">전체</td>
                                <td>{{ literTime.ok }}%</td>
                                <td>{{ literTime.over }}%</td>
                                <td>{{ literTime.warn }}%</td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="contents__data">
                        <button type="button" class="btn__view-detail">?</button>
                        <dl>
                            <dt>• 핵심 소재 및 내용 파악</dt>
                            <dd>{{ kreadData.currentKread?.analysis509001Rate }}%</dd>
                        </dl>
                        <dl>
                            <dt>• 중심 내용 파악 및 구조화</dt>
                            <dd>완료</dd>
                        </dl>
                        <dl>
                            <dt>• 주제 및 핵심 표현 정리</dt>
                            <dd>{{ kreadData.currentKread?.analysis509201Rate }}%</dd>
                        </dl>
                    </div>
                </div>
                <div class="contents">
                    <span class="contents__title">비문학</span>
                    <table class="kread-detail__table">
                        <thead>
                            <tr>
                                <th style="text-align: left">갈래</th>
                                <th>권장시간 준수</th>
                                <th>권장시간 초과</th>
                                <th>주의</th>
                            </tr>
                        </thead>
                        <tbody v-if="splitTableData.nonLiterature">
                            <tr v-for="data in splitTableData.nonLiterature" :Key="data.kreadReportSplitSeq">
                                <td style="text-align: left">{{ data.splitName }}</td>
                                <td>{{ data.readTimeOkRate }}%</td>
                                <td>{{ data.readTimeOverRate }}%</td>
                                <td>{{ data.readTimeWarnRate }}%</td>
                            </tr>
                            <tr class="total">
                                <td style="text-align: left">전체</td>
                                <td>{{ nonLiterTime.ok }}%</td>
                                <td>{{ nonLiterTime.over }}%</td>
                                <td>{{ nonLiterTime.warn }}%</td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="contents__data">
                        <button type="button" class="btn__view-detail">?</button>
                        <dl>
                            <dt>• 핵심 소재 및 내용 파악</dt>
                            <dd>{{ kreadData.currentKread?.analysis509002Rate }}%</dd>
                        </dl>
                        <dl>
                            <dt>• 중심 내용 파악 및 구조화</dt>
                            <dd>완료</dd>
                        </dl>
                        <dl>
                            <dt>• 주제 및 핵심 표현 정리</dt>
                            <dd>{{ kreadData.currentKread?.analysis509202Rate }}%</dd>
                        </dl>
                    </div>
                </div>
            </section>
            <section class="kread-detail__part achievement">
                <h4 class="part__title">문항 난이도별 드릴 비중 및 성취율</h4>
                <p class="part__desc">
                    {{ commentData.sbReportDrill }}
                </p>
                <div class="contents__wrap">
                    <div class="contents">
                        <span class="contents__title">문학</span>
                        <div class="column-chart__wrap">
                            <span class="chart__title">• 성취율</span>
                            <LineChart v-if="lineChartData.literature" :chartData="lineChartData.literature" height="15vw" width="93%" />
                        </div>
                        <!-- <div class="chart-label">
                            <span class="label-color">이전 출제율&성취율</span>
                        </div> -->
                        <div class="column-chart__wrap" style="background-color: #fafafa">
                            <span class="chart__title">• 출제율</span>
                            <ColumChart v-if="columChartData.literature" :chartData="columChartData.literature" :colorFixed="false" height="16vw" width="93%" />
                        </div>
                    </div>
                    <div class="contents">
                        <span class="contents__title">비문학</span>
                        <div class="column-chart__wrap">
                            <span class="chart__title">• 성취율</span>
                            <LineChart v-if="lineChartData.nonLiterature" :chartData="lineChartData.nonLiterature" height="15vw" width="93%" />
                        </div>
                        <div class="column-chart__wrap" style="background-color: #fafafa">
                            <span class="chart__title">• 출제율</span>
                            <ColumChart v-if="columChartData.nonLiterature" :chartData="columChartData.nonLiterature" :colorFixed="false" height="16vw" width="93%" />
                        </div>
                    </div>
                </div>
            </section>
            <section class="kread-detail__part strength">
                <h4 class="part__title">
                    사고 유형별 강약점
                    <button type="button" class="btn__view-detail">?</button>
                </h4>
                <p class="part__desc">
                    {{ commentData.sbAnalysisThink }}
                </p>
                <div class="contents__wrap">
                    <div class="contents">
                        <ColumChart v-if="cogitationList" :chartData="cogitationList" height="25vw" />
                    </div>
                </div>
            </section>
            <section class="kread-detail__part strength">
                <h4 class="part__title">
                    질문 유형별 강약점
                    <button type="button" class="btn__view-detail">?</button>
                </h4>
                <p class="part__desc">{{ commentData.sbAnalysisType }}</p>
                <div class="contents__wrap">
                    <div class="contents">
                        <ColumChart v-if="questionList" :chartData="questionList" height="25vw" />
                    </div>
                </div>
            </section>
            <section class="kread-detail__part strength">
                <h4 class="part__title">
                    어휘 기초력
                    <button type="button" class="btn__view-detail">?</button>
                </h4>
                <p class="part__desc">
                    {{ commentData.sbAnalysisVoca }}
                </p>
                <div class="contents__wrap">
                    <div class="contents">
                        <ColumChart v-if="vocabularyList" :chartData="vocabularyList" height="25vw" />
                    </div>
                </div>
            </section>
        </section>
        <div v-if="isListItem" class="mg_top_48 mg_bottom_72 btn__wrap" style="text-align: center">
            <CusButton :type="462" :label="`분석리포트 홈`" @onReturn="emit('close')" />
        </div>
        <!-- <button type="button" class="btn__move" @click="movePage()">분석리포트 홈</button> -->
    </div>
</template>

<script setup>
import KreadChart from '@/components/chart/kreadChart.vue';
import LineChart from '@/components/chart/lineChart.vue';
import ColumChart from '@/components/chart/compareColumChart.vue';
import CusButton from '@/components/widget/CusButton.vue';
import { onMounted, ref, reactive } from 'vue';
import { getTimeStringSecondsKor } from '@/helpers/utils';
import moment from 'moment';

const emit = defineEmits(['close']);
const props = defineProps({
    reportData: {
        default: null,
    },
    isListItem: { default: false },
});

const nextKreadRange = ref();
const nextKreadRangeFilter = () => {
    switch (kreadData.currentKread.nextLearningLesson) {
        case '1레벨 49레슨':
            nextKreadRange.value = 'KReaD 1300-1399';
            break;
        case '2레벨 1레슨':
        case '2레벨 49레슨':
            nextKreadRange.value = 'KReaD 1400-1499';
            break;
        case '3레벨 1레슨':
            nextKreadRange.value = 'KReaD 1500-1599';
            break;
        case '3레벨 49레슨':
            nextKreadRange.value = '';
            break;
        default:
            kreadData.currentKread.nextLearningLesson = '완료';
    }
};

//독해력 분석 차트
const kreadTotalChartData = reactive([]);
const kreadChartData = () => {
    let nextKreadLesson;
    kreadData.totalChartList?.forEach((item, idx) => {
        const lineChartObj = {
            category: null,
            value1: null,
            value2: null,
        };
        if (item.accuracyRate !== 0) nextKreadLesson = idx + 1;
        lineChartObj.category = item.kreadReportRangeNm;
        lineChartObj.value1 = null;
        lineChartObj.value2 = item.accuracyRate == 0 ? null : item.accuracyRate;
        kreadTotalChartData.push(lineChartObj);
    });
    //마지막 index인지 체크
    if (!kreadTotalChartData[nextKreadLesson] == false) {
        kreadTotalChartData[nextKreadLesson].value1 = 1;
    }
};

//권장시간 합산
const literTime = reactive({
    ok: 0,
    over: 0,
    warn: 0,
});
const nonLiterTime = reactive({
    ok: 0,
    over: 0,
    warn: 0,
});
const timeAverage = () => {
    //문학
    kreadData.splitList
        .filter((item) => item.areaCode == 1)
        .forEach((t) => {
            literTime.ok += t.readTimeOkRate;
            literTime.over += t.readTimeOverRate;
            literTime.warn += t.readTimeWarnRate;
        });
    literTime.ok = (literTime.ok / splitTableData.litherature?.length).toFixed(); //정수로 변경
    literTime.over = (literTime.over / splitTableData.litherature?.length).toFixed();
    literTime.warn = (literTime.warn / splitTableData.litherature?.length).toFixed();
    //비문학
    kreadData.splitList
        .filter((item) => item.areaCode == 2)
        .forEach((t) => {
            nonLiterTime.ok += t.readTimeOkRate;
            nonLiterTime.over += t.readTimeOverRate;
            nonLiterTime.warn += t.readTimeWarnRate;
        });
    nonLiterTime.ok = (nonLiterTime.ok / splitTableData.nonLiterature?.length).toFixed();
    nonLiterTime.over = (nonLiterTime.over / splitTableData.nonLiterature?.length).toFixed();
    nonLiterTime.warn = (nonLiterTime.warn / splitTableData.nonLiterature?.length).toFixed();
};

//난이도별 성취율 비교
const lineChartData = reactive({
    literature: '',
    nonLiterature: '',
});
const columChartData = reactive({
    literature: '',
    nonLiterature: '',
});
const difficultyLevel = () => {
    //문학
    lineChartData.literature = [
        { category: '심화', value1: kreadData.beforeKread?.tc01Rate, value2: kreadData.currentKread?.tc01Rate },
        { category: '핵심', value1: kreadData.beforeKread?.tb01Rate, value2: kreadData.currentKread?.tb01Rate },
        { category: '기초', value1: kreadData.beforeKread?.ta01Rate, value2: kreadData.currentKread?.ta01Rate },
    ];
    columChartData.literature = [
        { category: '심화', value1: kreadData.beforeKread?.problem01TcRate, value2: kreadData.currentKread?.problem01TcRate, ord: 3 },
        { category: '핵심', value1: kreadData.beforeKread?.problem01TbRate, value2: kreadData.currentKread?.problem01TbRate, ord: 2 },
        { category: '기초', value1: kreadData.beforeKread?.problem01TaRate, value2: kreadData.currentKread?.problem01TaRate, ord: 1 },
    ];
    //비문학
    lineChartData.nonLiterature = [
        { category: '심화', value1: kreadData.beforeKread?.tc02Rate, value2: kreadData.currentKread?.tc02Rate },
        { category: '핵심', value1: kreadData.beforeKread?.tb02Rate, value2: kreadData.currentKread?.tb02Rate },
        { category: '기초', value1: kreadData.beforeKread?.ta02Rate, value2: kreadData.currentKread?.ta02Rate },
    ];
    columChartData.nonLiterature = [
        { category: '심화', value1: kreadData.beforeKread?.problem02TcRate, value2: kreadData.currentKread?.problem02TcRate, ord: 3 },
        { category: '핵심', value1: kreadData.beforeKread?.problem02TbRate, value2: kreadData.currentKread?.problem02TbRate, ord: 2 },
        { category: '기초', value1: kreadData.beforeKread?.problem02TaRate, value2: kreadData.currentKread?.problem02TaRate, ord: 1 },
    ];
};

//사고 유형별 강약점
const cogitationList = ref();
const accidentType = () => {
    cogitationList.value = [
        { category: '사실적 독해', value1: kreadData.beforeKread?.analysis5077Rate, value2: kreadData.currentKread.analysis5077Rate, ord: 1 },
        { category: '추론적 독해', value1: kreadData.beforeKread?.analysis5078Rate, value2: kreadData.currentKread.analysis5078Rate, ord: 2 },
        { category: '비판적 독해', value1: kreadData.beforeKread?.analysis5079Rate, value2: kreadData.currentKread.analysis5079Rate, ord: 3 },
        { category: '감상적 독해', value1: kreadData.beforeKread?.analysis5085Rate, value2: kreadData.currentKread.analysis5085Rate, ord: 4 },
        { category: '개념', value1: kreadData.beforeKread?.analysis5080Rate, value2: kreadData.currentKread.analysis5080Rate, ord: 5 },
        { category: '어휘', value1: kreadData.beforeKread?.analysis5081Rate, value2: kreadData.currentKread.analysis5081Rate, ord: 6 },
    ];
};

//질문 유형별 강약점
const questionList = ref();
const questionType = () => {
    questionList.value = [
        { category: '전체 내용을 묻는 질문', value1: kreadData.beforeKread?.typeAllRate, value2: kreadData.currentKread.typeAllRate, ord: 1 },
        { category: '세부 내용을 묻는 질문', value1: kreadData.beforeKread?.typePartRate, value2: kreadData.currentKread.typePartRate, ord: 2 },
        { category: '긍정형 질문', value1: kreadData.beforeKread?.typePositiveRate, value2: kreadData.currentKread.typePositiveRate, ord: 3 },
        { category: '부정형 질문', value1: kreadData.beforeKread?.typeNegativeRate, value2: kreadData.currentKread.typeNegativeRate, ord: 4 },
        { category: '<보기> 있는 질문', value1: kreadData.beforeKread?.typeOptionExistRate, value2: kreadData.currentKread.typeOptionExistRate, ord: 5 },
        { category: '<보기> 없는 질문', value1: kreadData.beforeKread?.typeOptionNoneRate, value2: kreadData.currentKread.typeOptionNoneRate, ord: 6 },
    ];
};

//어휘 기초력
const vocabularyList = ref();
const vocabularyGround = () => {
    vocabularyList.value = [
        { category: '어휘의 사전적 의미 파악', value1: kreadData.beforeKread?.kreadReportRangeSeq == 1 ? null : kreadData.beforeKread?.analysis5093Rate, value2: kreadData.currentKread.analysis5093Rate, ord: 1 },
        { category: '예문을 통한 어휘의 쓰임 파악', value1: kreadData.beforeKread?.kreadReportRangeSeq == 1 ? null : kreadData.beforeKread?.analysis5094Rate, value2: kreadData.currentKread.analysis5094Rate, ord: 2 },
        { category: '바꾸어 쓸 어휘의 적절성 파악', value1: kreadData.beforeKread?.kreadReportRangeSeq == 1 ? null : kreadData.beforeKread?.analysis5095Rate, value2: kreadData.currentKread.analysis5095Rate, ord: 3 },
        { category: '사자성어를 통한 어휘 확장', value1: kreadData.beforeKread?.kreadReportRangeSeq == 1 ? null : kreadData.beforeKread?.analysis5096Rate, value2: kreadData.currentKread.analysis5096Rate, ord: 4 },
    ];
};
//kread data
const kreadData = reactive({
    beforeKread: null,
    currentKread: null,
    forderList: null,
    splitList: null,
    totalChartList: null,
});
//comment data
const commentData = reactive({
    sbReportOverall: null,
    sbSubSubject: null,
    sbReportSplitSubject: null,
    sbReportForder03: null,
    sbReportReadTime: null,
    sbReportDrill: null,
    sbAnalysisThink: null,
    sbAnalysisType: null,
    sbAnalysisVoca: null,
});
//갈래별 데이터 (krt_kread_report_split)
const splitTableData = reactive({
    litherature: '',
    nonLiterature: '',
});

//개념별 데이터 (krt_kread_report_folder03)
const literConcept = ref();
const nonliterConcept = ref();
onMounted(() => {
    console.log('propsData:::::::::::::::::::::::::::::', props.reportData);
    //코멘트
    commentData.sbReportOverall = props.reportData.sbReportOverall;
    commentData.sbSubSubject = props.reportData.sbSubSubject;
    commentData.sbReportSplitSubject = props.reportData.sbReportSplitSubject;
    commentData.sbReportForder03 = props.reportData.sbReportForder03;
    commentData.sbReportReadTime = props.reportData.sbReportReadTime;
    commentData.sbReportDrill = props.reportData.sbReportDrill;
    commentData.sbAnalysisThink = props.reportData.sbAnalysisThink;
    commentData.sbAnalysisType = props.reportData.sbAnalysisType;
    commentData.sbAnalysisVoca = props.reportData.sbAnalysisVoca;
    //그 외
    kreadData.beforeKread = props.reportData.beforeKreadReport;
    kreadData.currentKread = props.reportData.currentKreadReport;
    kreadData.splitList = props.reportData.kreadReportSplitList;
    kreadData.forderList = props.reportData.kreadReportForderList;
    kreadData.totalChartList = props.reportData.kreadReportTotalChartList;

    //다음 학습 kread 범위
    nextKreadRangeFilter();

    //갈래별 데이터 분리(krt_kread_report_split)
    splitTableData.litherature = [...kreadData.splitList.filter((item) => item.areaCode == 1)];
    splitTableData.nonLiterature = [...kreadData.splitList.filter((item) => item.areaCode == 2)];
    console.log('splitTableData', splitTableData);

    //개념별 데이터
    literConcept.value = [...kreadData.forderList.filter((item) => item.areaCode == 1)];
    nonliterConcept.value = [...kreadData.forderList.filter((item) => item.areaCode == 2)];

    // 독해력 차트
    kreadChartData();
    //난이도별 성취율&출제율.
    difficultyLevel();
    //사고 유형별
    accidentType();
    //질문 유형별
    questionType();
    //어휘 기초력
    vocabularyGround();
    //갈래별 권장시간 합산
    timeAverage();
});
</script>

<style scoped>
@media all and (max-width: 2000px) {
    .reading-report {
        width: 100%;
        padding-bottom: 10vw;
    }
    .reading-report .report__header {
        display: flex;
        align-items: center;
        position: relative;
        height: 4.3vw;
        padding: 1vw 2vw;
        border-bottom: 1px solid #e0e0e0;
        box-sizing: border-box;
    }
    .reading-report .report__header .header__title {
        margin-left: 1.2vw;
        font-size: 1.4vw;
    }
    .reading-report .report__overview {
        display: flex;
        justify-content: space-between;
        width: 100%;
        padding: 4vw 10vw;
        background-color: #fafafa;
        box-sizing: border-box;
    }
    .reading-report .report__overview .overview__info .info__grade {
        display: block;
        font-size: 1.4vw;
        line-height: 150%;
    }
    .reading-report .report__overview .overview__info .info__title {
        margin-top: 0.8vw;
        font-size: 2.2vw;
        line-height: 3.3vw;
    }
    .reading-report .report__overview .overview__info .info__lesson {
        margin-top: 0.4vw;
        color: #18b73f;
        font-size: 1.8vw;
        font-weight: 600;
        line-height: 150%; /* 2.7vw */
    }
    .reading-report .report__overview .overview__info .info__date {
        position: relative;
        display: flex;
        margin-top: 2vw;
        padding-left: 3vw;
        color: #666;
        font-size: 1.3vw;
        line-height: 2.1vw;
    }
    .reading-report .report__overview .overview__info .info__date:before {
        content: '';
        display: block;
        position: absolute;
        left: 0;
        width: 2.1vw;
        height: 2.1vw;
        /* background: url('/assets/images/ico_report_calender.svg') no-repeat; */
        background-size: 100% 100%;
    }
    .reading-report .report__overview .overview__chart {
        display: flex;
        justify-content: space-between;
        align-items: center;
        min-width: 34vw;
        padding: 3.5vw 5vw;
        background-color: #fff;
        border-radius: 2vw;
    }
    .reading-report .report__overview .overview__chart .gauge-chart {
        width: 16vw;
        height: 12vw;
    }
    .reading-report .report__overview .overview__chart .gauge-chart__wrap {
        position: relative;
        width: 16vw;
        margin-right: 2.1vw;
    }
    .reading-report .report__overview .overview__chart .gauge-chart__data {
        position: absolute;
        left: 50%;
        top: 4vw;
        transform: translateX(-50%);
    }
    .reading-report .report__overview .overview__chart .gauge-chart__title {
        display: flex;
        align-items: center;
        color: #666;
        font-size: 1.2vw;
        line-height: 150%;
    }
    .reading-report .report__overview .overview__chart .gauge-chart__percent {
        margin-top: 0.3vw;
        color: #222;
        font-size: 1.2vw;
        font-weight: 600;
        line-height: 1.6vw;
    }
    .reading-report .report__overview .overview__chart .gauge-chart__percent__emphasis {
        font-size: 3.7vw;
        font-weight: 700;
        line-height: 3.3vw;
    }
    .reading-report .report__overview .overview__chart .progress-chart {
        width: 16vw;
        height: 3vw;
        margin-top: 2.1vw;
    }
    .reading-report .report__overview .overview__chart .chart__info {
        flex: 1;
    }
    .reading-report .report__overview .overview__chart .chart__info dt {
        color: #666;
        font-size: 20.4vw;
        font-weight: 600;
        line-height: 150%;
    }
    .reading-report .report__overview .overview__chart .chart__info dd {
        margin-top: 0.4vw;
        color: #222;
        font-size: 1.7vw;
        font-weight: 600;
        line-height: 150%;
    }
    .reading-report .report__section {
        margin-top: 4vw;
        padding: 0 10vw;
        box-sizing: border-box;
    }
    .reading-report .report__section__title {
        margin-bottom: 1.2vw;
        color: #222;
        font-size: 1.8vw;
        font-weight: 700;
        line-height: 150%;
    }
    .reading-report .report__section .analyze-result__data {
        display: flex;
        flex-wrap: wrap;
        margin: -0.5vw;
    }
    .reading-report .report__section .analyze-result__data .data {
        margin-top: 1.2vw;
        text-align: right;
        color: #ccc;
        font-size: 1.8vw;
        font-weight: 600;
        text-align: center;
        line-height: 3vw;
    }
    .reading-report .report__section .analyze-result__data .data__title {
        color: #222;
        font-size: 1.2vw;
        font-weight: 600;
        line-height: 150%;
        text-align: center;
    }
    .reading-report .report__section .analyze-result__data .data__title .btn__view-detail {
        position: absolute;
        top: 0.5vw;
        right: 0.5vw;
    }
    .reading-report .report__section .analyze-result__data .data__list {
        position: relative;
        margin: 0.5vw;
        padding: 2vw 1vw 1vw 1vw;
        border-radius: 0.8vw;
        background: #f7f5fd;
        box-sizing: border-box;
    }
    .reading-report .report__section .analyze-result__data .data__list:nth-child(1),
    .reading-report .report__section .analyze-result__data .data__list:nth-child(2),
    .reading-report .report__section .analyze-result__data .data__list:nth-child(3),
    .reading-report .report__section .analyze-result__data .data__list:nth-child(4),
    .reading-report .report__section .analyze-result__data .data__list:nth-child(5) {
        flex: 1;
    }
    .reading-report .report__section .analyze-result__data .data__past {
        display: flex;
        align-items: center;
        justify-content: space-between;
        position: absolute;
        bottom: 1vw;
        width: calc(100% - 2vw);
        margin-top: 0.4vw;
        padding: 0.8vw;
        background-color: #fff;
        color: #666;
        font-size: 1.1vw;
        font-weight: 600;
        line-height: 150%;
        border-radius: 0.4vw;
    }
    .reading-report .report__section .analyze-result__data .data__past__title {
        display: inline-block;
        margin-right: 0.6vw;
        font-size: 0.8vw;
    }
    .reading-report .report__section .analyze-result__data .data__desc {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 3.7vw;
        margin-top: 0.4vw;
        color: #666;
        font-size: 1.3vw;
        line-height: 150%;
    }
    .reading-report .report__section .analyze-result__data .data__dim {
        padding-left: 0.3vw;
        color: #ccc;
    }
    .reading-report .report__section .analyze-result__chart {
        width: 100%;
        margin-top: 1vw;
        padding: 3vw;
        background-color: #fafafa;
        border-radius: 1vw;
        box-sizing: border-box;
    }
    .reading-report .report__section .analyze-result__chart .line-chart {
        width: 100%;
        height: 29.2vw;
    }
    .reading-report .report__section .analyze-result__text {
        margin-top: 1.5vw;
        color: #666;
        font-size: 1.5vw;
        line-height: 180%; /* 54px */
    }
    .reading-report .report__section .kread-reading__text {
        color: #666;
        font-size: 1.5vw;
        line-height: 180%; /* 54px */
    }
    .reading-report .report__section .kread-reading__graph {
        min-height: 10vw;
        margin-top: 1.35vw;
    }
    .reading-report .report__section .kread-reading__graph__wrap {
        margin-top: 2vw;
        padding: 3vw 4vw;
        background-color: #fafafa;
        border-radius: 1vw;
    }
    .reading-report .report__section .kread-reading__graph__title {
        margin-bottom: 1.2vw;
        color: #222;
        font-size: 1.6vw;
        font-weight: 700;
        line-height: 150%; /* 40.4vw */
    }
    .reading-report .report__section .kread-reading__table {
        width: 100%;
        margin-top: 2vw;
    }
    .reading-report .report__section .kread-reading__table thead {
        border-top: 1px solid #222;
    }
    .reading-report .report__section .kread-reading__table tbody {
        border-bottom: 1px solid #222;
    }
    .reading-report .report__section .kread-reading__table tr {
        width: 100%;
    }
    .reading-report .report__section .kread-reading__table tr + tr {
        border-top: 1px solid #ddd;
    }
    .reading-report .report__section .kread-reading__table th {
        padding: 1.2vw 3vw;
        background: #fafafa;
        border-bottom: 1px solid #ddd;
        color: #222;
        font-size: 1.2vw;
        font-weight: 600;
        line-height: 1.6vw;
        text-align: center;
    }
    .reading-report .report__section .kread-reading__table td {
        padding: 1.5vw 3vw;
        color: #666;
        font-size: 1.3vw;
        font-weight: 400;
        line-height: 150%;
        text-align: center;
    }
    .reading-report .report__section .kread-detail__part {
        margin-bottom: 4vw;
    }
    .reading-report .report__section .kread-detail__part:last-of-type {
        margin-bottom: 0;
    }
    .reading-report .report__section .kread-detail__part .part__title {
        position: relative;
        padding-left: 1vw;
        color: #222;
        font-size: 1.6vw;
        font-weight: 700;
        line-height: 150%;
    }
    .reading-report .report__section .kread-detail__part .part__title:first-of-type {
        margin-top: 0;
    }
    .reading-report .report__section .kread-detail__part .part__title:before {
        content: '';
        display: block;
        position: absolute;
        top: 1vw;
        left: 0;
        width: 0.4vw;
        height: 0.4vw;
        background-color: #000;
        border-radius: 100%;
    }
    .reading-report .report__section .kread-detail__part .part__desc {
        margin-top: 0.8vw;
        padding: 0 1vw;
        color: #666;
        font-size: 1.4vw;
        font-weight: 400;
        line-height: 2.4vw;
    }
    .reading-report .report__section .kread-detail__part .contents {
        flex: 1;
        width: calc(50% - 0.5vw);
        margin-right: 1vw;
        padding: 3vw;
        border: 1px solid #ddd;
        border-radius: 0.8vw;
        box-sizing: border-box;
    }
    .reading-report .report__section .kread-detail__part .contents:last-of-type {
        margin-right: 0;
    }
    .reading-report .report__section .kread-detail__part .contents__wrap {
        display: flex;
        justify-content: space-between;
        width: 100%;
        margin-top: 2vw;
    }
    .reading-report .report__section .kread-detail__part .contents__title {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 3.7vw;
        background: #f7f5fd;
        border-radius: 0.4vw;
        color: #222;
        font-size: 1.4vw;
        font-weight: 700;
        line-height: 150%;
    }
    .reading-report .report__section .kread-detail__part .contents__data {
        position: relative;
        margin-top: 3vw;
        padding: 1.2vw 0;
    }
    .reading-report .report__section .kread-detail__part .contents__data .data {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
    }
    .reading-report .report__section .kread-detail__part .contents__data .data__label {
        color: #666;
        font-size: 1.1vw;
        line-height: 150%; /* 33px */
        text-align: right;
    }
    .reading-report .report__section .kread-detail__part .contents__data .data__label > span {
        padding-left: 1.5vw;
    }
    .reading-report .report__section .kread-detail__part .contents__data .data__label > span:first-child {
        padding-left: 0;
    }
    .reading-report .report__section .kread-detail__part .contents__data .data__list {
        margin-top: 1.6vw;
        text-align: left;
    }
    .reading-report .report__section .kread-detail__part .contents__data .data__title {
        color: #666;
        font-size: 1.2vw;
        font-weight: 600;
        line-height: 150%; /* 1.8vw */
    }
    .reading-report .report__section .kread-detail__part .contents__data .data .progress__wrap {
        width: 17.5vw;
    }
    .reading-report .report__section .kread-detail__part .contents__data .data .progress__wrap progress {
        overflow: hidden;
        -webkit-appearance: none;
        width: 100%;
        height: 1.5vw;
        margin-top: 0.4vw;
        border-radius: 1vw;
    }
    .reading-report .report__section .kread-detail__part .contents__data .data .progress__wrap progress::-webkit-progress-bar {
        background-color: #dddddd;
        /* 성취율 배경색 */
    }

    .reading-report .report__section .kread-detail__part .contents__data .data .progress__wrap progress::-webkit-progress-value {
        background-color: #18b73f;
        border-radius: 1vw;
    }
    .reading-report .report__section .kread-detail__part .contents__data .data .progress__wrap progress:nth-child(2)::-webkit-progress-value {
        background-color: #9f9f9f;
    }
    .reading-report .report__section .kread-detail__part .contents__data .data .progress__label {
        color: #9f9f9f;
        text-align: center;
        font-size: 2vw;
        font-weight: 600;
        line-height: 150%; /* 3vw */
    }
    .reading-report .report__section .kread-detail__part .contents__data .data .progress__label:nth-child(2) {
        color: #18b73f;
    }
    .reading-report .report__section .kread-detail__part .contents__data .btn__view-detail {
        position: absolute;
        top: 0.4vw;
        right: 0.4vw;
    }
    .reading-report .report__section .kread-detail__part.type2 .contents,
    .reading-report .report__section .kread-detail__part.type3 .contents {
        width: 100%;
        margin-top: 2vw;
        margin-right: 0;
        padding: 0;
        border: none;
        border-radius: 0;
    }
    .reading-report .report__section .kread-detail__part.type2 .contents + .contents,
    .reading-report .report__section .kread-detail__part.type3 .contents + .contents {
        margin-top: 3vw;
    }
    .reading-report .report__section .kread-detail__part.type2 .contents th,
    .reading-report .report__section .kread-detail__part.type2 .contents td,
    .reading-report .report__section .kread-detail__part.type3 .contents th,
    .reading-report .report__section .kread-detail__part.type3 .contents td {
        padding: 1.25vw 1.5vw;
    }
    .reading-report .report__section .kread-detail__part.type2 .contents td.emphasis,
    .reading-report .report__section .kread-detail__part.type3 .contents td.emphasis {
        color: #18b73f;
        font-weight: 700;
    }
    .reading-report .report__section .kread-detail__part.type2 .contents__data,
    .reading-report .report__section .kread-detail__part.type3 .contents__data {
        position: relative;
        margin-top: 3vw;
        padding: 2.7vw 2vw 1.2vw;
        background-color: #fafafa;
    }
    .reading-report .report__section .kread-detail__part.type2 .contents__data dl,
    .reading-report .report__section .kread-detail__part.type3 .contents__data dl {
        display: flex;
        padding: 0.8vw 0;
        border-bottom: 1px solid #ddd;
    }
    .reading-report .report__section .kread-detail__part.type2 .contents__data dl:last-of-type,
    .reading-report .report__section .kread-detail__part.type3 .contents__data dl:last-of-type {
        border-bottom: none;
    }
    .reading-report .report__section .kread-detail__part.type2 .contents__data dl dt,
    .reading-report .report__section .kread-detail__part.type3 .contents__data dl dt {
        width: 19vw;
        color: #666;
        font-size: 1.3vw;
        font-weight: 400;
        line-height: 170%;
        text-align: left;
    }
    .reading-report .report__section .kread-detail__part.type2 .contents__data dl dd,
    .reading-report .report__section .kread-detail__part.type3 .contents__data dl dd {
        color: #222;
        font-size: 1.3vw;
        font-weight: 700;
        line-height: 170%;
    }
    .reading-report .report__section .kread-detail__part.type2 .contents__data .btn__view-detail,
    .reading-report .report__section .kread-detail__part.type3 .contents__data .btn__view-detail {
        position: absolute;
        top: 0.4vw;
        right: 0.4vw;
    }
    .reading-report .report__section .kread-detail__part.type2 .kread-detail__table,
    .reading-report .report__section .kread-detail__part.type3 .kread-detail__table {
        width: 100%;
        margin-top: 1.25vw;
        border-bottom: 1px solid #222;
    }
    .reading-report .report__section .kread-detail__part.type2 .kread-detail__table thead,
    .reading-report .report__section .kread-detail__part.type3 .kread-detail__table thead {
        border-top: 1px solid #222;
    }
    .reading-report .report__section .kread-detail__part.type2 .kread-detail__table tbody + tbody tr:first-of-type,
    .reading-report .report__section .kread-detail__part.type3 .kread-detail__table tbody + tbody tr:first-of-type {
        border-top: 1px solid #222;
    }
    .reading-report .report__section .kread-detail__part.type2 .kread-detail__table tbody + tbody tr:last-of-type,
    .reading-report .report__section .kread-detail__part.type3 .kread-detail__table tbody + tbody tr:last-of-type {
        border-bottom: 1px solid #222;
    }
    .reading-report .report__section .kread-detail__part.type2 .kread-detail__table tr,
    .reading-report .report__section .kread-detail__part.type3 .kread-detail__table tr {
        width: 100%;
    }
    .reading-report .report__section .kread-detail__part.type2 .kread-detail__table tr + tr,
    .reading-report .report__section .kread-detail__part.type3 .kread-detail__table tr + tr {
        border-top: 1px solid #ddd;
    }
    .reading-report .report__section .kread-detail__part.type2 .kread-detail__table tr.total,
    .reading-report .report__section .kread-detail__part.type3 .kread-detail__table tr.total {
        background-color: #fffbeb;
    }
    .reading-report .report__section .kread-detail__part.type2 .kread-detail__table tr.total td,
    .reading-report .report__section .kread-detail__part.type3 .kread-detail__table tr.total td {
        font-weight: 600;
    }
    .reading-report .report__section .kread-detail__part.type2 .kread-detail__table th,
    .reading-report .report__section .kread-detail__part.type3 .kread-detail__table th {
        padding: 1.2vw 3vw;
        background: #fafafa;
        border-bottom: 1px solid #ddd;
        color: #222;
        font-size: 1.2vw;
        font-weight: 600;
        line-height: 1.6vw;
        text-align: center;
    }
    .reading-report .report__section .kread-detail__part.type2 .kread-detail__table td,
    .reading-report .report__section .kread-detail__part.type3 .kread-detail__table td {
        padding: 1.5vw 3vw;
        color: #666;
        font-size: 1.3vw;
        font-weight: 400;
        line-height: 150%;
        text-align: center;
    }
    .reading-report .report__section .kread-detail__part.achievement .contents {
        padding-bottom: 0;
    }
    .reading-report .report__section .kread-detail__part.achievement .chart__title {
        display: block;
        margin-top: 2vw;
        color: #18b73f;
        font-size: 1.2vw;
        font-weight: 600;
        line-height: 150%; /* 1.8vw */
        text-align: left;
    }
    .reading-report .report__section .kread-detail__part.achievement .line-chart {
        height: 12vw;
        margin-top: 1.3vw;
    }
    .reading-report .report__section .kread-detail__part.achievement .column-chart {
        width: calc(100% - 6vw);
        height: 12.25vw;
        margin: 0.65vw auto 3vw;
    }
    .reading-report .report__section .kread-detail__part.achievement .column-chart__wrap {
        overflow: hidden;
        position: relative;
        width: calc(100% + 6vw);
        margin-top: 2vw;
        margin-left: -3vw;
    }
    .reading-report .report__section .kread-detail__part.achievement .column-chart__wrap:before {
        content: '';
        display: block;
        position: absolute;
        z-index: -1;
        width: 100%;
        height: 100%;
        /* background-color: #fafafa; */
        border-radius: 0 0 0.8vw 0.8vw;
    }
    .reading-report .report__section .kread-detail__part.achievement .column-chart__wrap .chart__title {
        padding-left: 3vw;
    }
    .reading-report .report__section .strength .contents {
        height: 30vw;
        padding: 3vw;
        background-color: #fafafa;
        border: none;
    }
    .reading-report .report__section .strength .contents .column-chart {
        width: 100%;
        height: 100%;
    }
    .reading-report .report__section .emphasis {
        color: #18b73f;
        font-weight: 700;
    }
    .reading-report .btn__move-prev {
        width: 2.4vw;
        height: 2.4vw;
        background: url('@/assets/images/icon/ico_arrow_back.svg') no-repeat center;
        text-indent: -9999rem;
        background-size: 100% 100%;
    }
    .reading-report .btn__print {
        position: absolute;
        right: 2vw;
        width: 2.4vw;
        height: 2.4vw;
        /* background: url('/assets/images/ico_print.svg') no-repeat center; */
        text-indent: -9999rem;
        background-size: 100% 100%;
    }
    .reading-report .btn__view-detail {
        width: 2.4vw;
        height: 2.4vw;
        /* background: url('/assets/images/ico_tip.svg') no-repeat center; */
        text-indent: -9999rem;
        background-size: 100% 100%;
    }
    .reading-report .btn__move {
        display: flex;
        width: 19.8vw;
        height: 4.9vw;
        margin: 4vw auto 0;
        padding: 0.75vw 1.7vw;
        justify-content: center;
        align-items: center;
        border: 1px solid #222;
        border-radius: 0.8vw;
        font-size: 1.2vw;
        font-weight: 700;
    }
}
@media all and (min-width: 2001px) {
    .reading-report {
        width: 100%;
        max-width: 2000px;
        margin: 0 auto;
        padding-bottom: 212px;
    }
    .reading-report .report__header {
        display: flex;
        align-items: center;
        position: relative;
        height: 85px;
        padding: 18px 40px;
        border-bottom: 1px solid #e0e0e0;
        box-sizing: border-box;
    }
    .reading-report .report__header .header__title {
        margin-left: 24px;
        font-size: 28px;
    }
    .reading-report .report__overview {
        display: flex;
        justify-content: space-between;
        width: 100%;
        padding: 80px 230px;
        background-color: #fafafa;
        box-sizing: border-box;
    }
    .reading-report .report__overview .overview__info .info__grade {
        display: block;
        font-size: 28px;
        line-height: 150%;
    }
    .reading-report .report__overview .overview__info .info__title {
        margin-top: 16px;
        font-size: 44px;
        line-height: 66px;
    }
    .reading-report .report__overview .overview__info .info__lesson {
        margin-top: 8px;
        color: #18b73f;
        font-size: 36px;
        font-weight: 600;
        line-height: 150%; /* 54px */
    }
    .reading-report .report__overview .overview__info .info__date {
        position: relative;
        display: flex;
        margin-top: 40px;
        padding-left: 60px;
        color: #666;
        font-size: 26px;
        line-height: 42px;
    }
    .reading-report .report__overview .overview__info .info__date:before {
        content: '';
        display: block;
        position: absolute;
        left: 0;
        width: 42px;
        height: 42px;
        /* background: url('/assets/images/ico_report_calender.svg') no-repeat; */
    }
    .reading-report .report__overview .overview__chart {
        display: flex;
        justify-content: space-between;
        align-items: center;
        min-width: 680px;
        padding: 70px 100px;
        background-color: #fff;
        border-radius: 40px;
    }
    .reading-report .report__overview .overview__chart .gauge-chart {
        width: 320px;
        height: 140px;
    }
    .reading-report .report__overview .overview__chart .gauge-chart__wrap {
        position: relative;
        width: 320px;
        margin-right: 42px;
    }
    .reading-report .report__overview .overview__chart .gauge-chart__data {
        position: absolute;
        left: 50%;
        top: 80px;
        transform: translateX(-50%);
    }
    .reading-report .report__overview .overview__chart .gauge-chart__title {
        display: flex;
        align-items: center;
        color: #666;
        font-size: 24px;
        line-height: 150%;
    }
    .reading-report .report__overview .overview__chart .gauge-chart__percent {
        margin-top: 6px;
        color: #222;
        font-size: 24px;
        font-weight: 600;
        line-height: 32px;
    }
    .reading-report .report__overview .overview__chart .gauge-chart__percent__emphasis {
        font-size: 74px;
        font-weight: 700;
        line-height: 66px;
    }
    .reading-report .report__overview .overview__chart .progress-chart {
        width: 320px;
        height: 60px;
        margin-top: 42px;
    }
    .reading-report .report__overview .overview__chart .chart__info {
        flex: 1;
    }
    .reading-report .report__overview .overview__chart .chart__info dt {
        color: #666;
        font-size: 28px;
        font-weight: 600;
        line-height: 150%;
    }
    .reading-report .report__overview .overview__chart .chart__info dd {
        margin-top: 8px;
        color: #222;
        font-size: 34px;
        font-weight: 600;
        line-height: 150%;
    }
    .reading-report .report__section {
        margin-top: 80px;
        padding: 0 230px;
        box-sizing: border-box;
    }
    .reading-report .report__section__title {
        margin-bottom: 24px;
        color: #222;
        font-size: 36px;
        font-weight: 700;
        line-height: 150%;
    }
    .reading-report .report__section .analyze-result__data {
        display: flex;
        flex-wrap: wrap;
        margin: -10px;
    }
    .reading-report .report__section .analyze-result__data .data {
        margin-top: 24px;
        text-align: right;
        color: #ccc;
        font-size: 36px;
        font-weight: 600;
        text-align: center;
        line-height: 60px;
    }
    .reading-report .report__section .analyze-result__data .data__title {
        color: #222;
        font-size: 24px;
        font-weight: 600;
        line-height: 150%;
        text-align: center;
    }
    .reading-report .report__section .analyze-result__data .data__title .btn__view-detail {
        position: absolute;
        top: 10px;
        right: 10px;
    }
    .reading-report .report__section .analyze-result__data .data__list {
        position: relative;
        margin: 10px;
        padding: 40px 20px 20px 20px;
        border-radius: 16px;
        background: #f7f5fd;
        box-sizing: border-box;
    }
    .reading-report .report__section .analyze-result__data .data__list:nth-child(1),
    .reading-report .report__section .analyze-result__data .data__list:nth-child(2),
    .reading-report .report__section .analyze-result__data .data__list:nth-child(3),
    .reading-report .report__section .analyze-result__data .data__list:nth-child(4),
    .reading-report .report__section .analyze-result__data .data__list:nth-child(5) {
        flex: 1;
    }
    .reading-report .report__section .analyze-result__data .data__past {
        display: flex;
        align-items: center;
        justify-content: space-between;
        position: absolute;
        bottom: 20px;
        width: calc(100% - 40px);
        margin-top: 8px;
        padding: 16px 20px;
        background-color: #fff;
        color: #666;
        font-size: 24px;
        font-weight: 600;
        line-height: 150%;
        border-radius: 8px;
    }
    .reading-report .report__section .analyze-result__data .data__past__title {
        display: inline-block;
        margin-right: 12px;
        font-size: 16px;
    }
    .reading-report .report__section .analyze-result__data .data__desc {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 74px;
        margin-top: 8px;
        color: #666;
        font-size: 26px;
        line-height: 150%;
    }
    .reading-report .report__section .analyze-result__data .data__dim {
        padding-left: 6px;
        color: #ccc;
    }
    .reading-report .report__section .analyze-result__chart {
        width: 100%;
        height: 584px;
        margin-top: 20px;
        padding: 60px;
        background-color: #fafafa;
        border-radius: 20px;
        box-sizing: border-box;
    }
    .reading-report .report__section .analyze-result__chart .line-chart {
        width: 100%;
        height: 480px;
    }
    .reading-report .report__section .analyze-result__text {
        margin-top: 30px;
        color: #666;
        font-size: 28px;
        line-height: 48px;
    }
    .reading-report .report__section .kread-reading__text {
        color: #666;
        font-size: 28px;
        line-height: 48px; /* 171.429% */
    }
    .reading-report .report__section .kread-reading__graph {
        min-height: 200px;
        margin-top: 27px;
    }
    .reading-report .report__section .kread-reading__graph__wrap {
        margin-top: 40px;
        padding: 60px 80px;
        background-color: #fafafa;
        border-radius: 20px;
    }
    .reading-report .report__section .kread-reading__graph__title {
        margin-bottom: 24px;
        color: #222;
        font-size: 32px;
        font-weight: 700;
        line-height: 150%; /* 48px */
    }
    .reading-report .report__section .kread-reading__table {
        width: 100%;
        margin-top: 40px;
    }
    .reading-report .report__section .kread-reading__table thead {
        border-top: 1px solid #222;
    }
    .reading-report .report__section .kread-reading__table tbody {
        border-bottom: 1px solid #222;
    }
    .reading-report .report__section .kread-reading__table tr {
        width: 100%;
    }
    .reading-report .report__section .kread-reading__table tr + tr {
        border-top: 1px solid #ddd;
    }
    .reading-report .report__section .kread-reading__table th {
        padding: 24px 60px;
        background: #fafafa;
        border-bottom: 1px solid #ddd;
        color: #222;
        font-size: 24px;
        font-weight: 600;
        line-height: 32px;
        text-align: center;
    }
    .reading-report .report__section .kread-reading__table td {
        padding: 30px 60px;
        color: #666;
        font-size: 26px;
        font-weight: 400;
        line-height: 150%;
        text-align: center;
    }
    .reading-report .report__section .kread-detail__part {
        margin-bottom: 80px;
    }
    .reading-report .report__section .kread-detail__part:last-of-type {
        margin-bottom: 0;
    }
    .reading-report .report__section .kread-detail__part .part__title {
        position: relative;
        padding-left: 20px;
        color: #222;
        font-size: 32px;
        font-weight: 700;
        line-height: 150%;
    }
    .reading-report .report__section .kread-detail__part .part__title:first-of-type {
        margin-top: 0;
    }
    .reading-report .report__section .kread-detail__part .part__title:before {
        content: '';
        display: block;
        position: absolute;
        top: 20px;
        left: 0;
        width: 8px;
        height: 8px;
        background-color: #000;
        border-radius: 100%;
    }
    .reading-report .report__section .kread-detail__part .part__desc {
        margin-top: 16px;
        padding: 0 20px;
        color: #666;
        font-size: 28px;
        font-weight: 400;
        line-height: 48px;
    }
    .reading-report .report__section .kread-detail__part .contents {
        flex: 1;
        margin-right: 20px;
        padding: 60px;
        border: 1px solid #ddd;
        border-radius: 16px;
        box-sizing: border-box;
    }
    .reading-report .report__section .kread-detail__part .contents:last-of-type {
        margin-right: 0;
    }
    .reading-report .report__section .kread-detail__part .contents__wrap {
        display: flex;
        justify-content: space-between;
        width: 100%;
        margin-top: 40px;
    }
    .reading-report .report__section .kread-detail__part .contents__title {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 74px;
        background: #f7f5fd;
        border-radius: 8px;
        color: #222;
        font-size: 28px;
        font-weight: 700;
        line-height: 150%;
    }
    .reading-report .report__section .kread-detail__part .contents__data {
        position: relative;
        margin-top: 60px;
        padding: 24px 0;
    }
    .reading-report .report__section .kread-detail__part .contents__data .data {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
    }
    .reading-report .report__section .kread-detail__part .contents__data .data__label {
        color: #666;
        font-size: 22px;
        line-height: 150%; /* 33px */
        text-align: right;
    }
    .reading-report .report__section .kread-detail__part .contents__data .data__label > span {
        padding-left: 30px;
    }
    .reading-report .report__section .kread-detail__part .contents__data .data__label > span:first-child {
        padding-left: 0;
    }
    .reading-report .report__section .kread-detail__part .contents__data .data__list {
        margin-top: 32px;
        text-align: left;
    }
    .reading-report .report__section .kread-detail__part .contents__data .data__title {
        color: #666;
        font-size: 24px;
        font-weight: 600;
        line-height: 150%; /* 36px */
    }
    .reading-report .report__section .kread-detail__part .contents__data .data .progress__wrap {
        width: 350px;
    }
    .reading-report .report__section .kread-detail__part .contents__data .data .progress__wrap progress {
        overflow: hidden;
        -webkit-appearance: none;
        width: 100%;
        height: 24px;
        margin-top: 8px;
        border-radius: 20px;
    }
    .reading-report .report__section .kread-detail__part .contents__data .data .progress__wrap progress::-webkit-progress-bar {
        background-color: #fafafa;
    }
    .reading-report .report__section .kread-detail__part .contents__data .data .progress__wrap progress::-webkit-progress-value {
        background-color: #18b73f;
        border-radius: 20px;
    }
    .reading-report .report__section .kread-detail__part .contents__data .data .progress__wrap progress:nth-child(2)::-webkit-progress-value {
        background-color: #ddd;
    }
    .reading-report .report__section .kread-detail__part .contents__data .data .progress__label {
        color: #9f9f9f;
        text-align: center;
        font-size: 40px;
        font-weight: 600;
        line-height: 150%; /* 60px */
    }
    .reading-report .report__section .kread-detail__part .contents__data .data .progress__label:nth-child(2) {
        color: #18b73f;
    }
    .reading-report .report__section .kread-detail__part .contents__data .btn__view-detail {
        position: absolute;
        top: 8px;
        right: 8px;
    }
    .reading-report .report__section .kread-detail__part.type2 .contents,
    .reading-report .report__section .kread-detail__part.type3 .contents {
        margin-top: 40px;
        margin-right: 0;
        padding: 0;
        border: none;
        border-radius: 0;
    }
    .reading-report .report__section .kread-detail__part.type2 .contents + .contents,
    .reading-report .report__section .kread-detail__part.type3 .contents + .contents {
        margin-top: 60px;
    }
    .reading-report .report__section .kread-detail__part.type2 .contents th,
    .reading-report .report__section .kread-detail__part.type2 .contents td,
    .reading-report .report__section .kread-detail__part.type3 .contents th,
    .reading-report .report__section .kread-detail__part.type3 .contents td {
        padding: 25px 30px;
    }
    .reading-report .report__section .kread-detail__part.type2 .contents td.emphasis,
    .reading-report .report__section .kread-detail__part.type3 .contents td.emphasis {
        color: #18b73f;
        font-weight: 700;
    }
    .reading-report .report__section .kread-detail__part.type2 .contents__data,
    .reading-report .report__section .kread-detail__part.type3 .contents__data {
        position: relative;
        margin-top: 60px;
        padding: 54px 40px 24px;
        background-color: #fafafa;
    }
    .reading-report .report__section .kread-detail__part.type2 .contents__data dl,
    .reading-report .report__section .kread-detail__part.type3 .contents__data dl {
        display: flex;
        padding: 16px 0;
        border-bottom: 1px solid #ddd;
    }
    .reading-report .report__section .kread-detail__part.type2 .contents__data dl:last-of-type,
    .reading-report .report__section .kread-detail__part.type3 .contents__data dl:last-of-type {
        border-bottom: none;
    }
    .reading-report .report__section .kread-detail__part.type2 .contents__data dl dt,
    .reading-report .report__section .kread-detail__part.type3 .contents__data dl dt {
        width: 381px;
        color: #666;
        font-size: 26px;
        font-weight: 400;
        line-height: 170%;
        text-align: left;
    }
    .reading-report .report__section .kread-detail__part.type2 .contents__data dl dd,
    .reading-report .report__section .kread-detail__part.type3 .contents__data dl dd {
        color: #222;
        font-size: 26px;
        font-weight: 700;
        line-height: 170%;
    }
    .reading-report .report__section .kread-detail__part.type2 .contents__data .btn__view-detail,
    .reading-report .report__section .kread-detail__part.type3 .contents__data .btn__view-detail {
        position: absolute;
        top: 8px;
        right: 8px;
    }
    .reading-report .report__section .kread-detail__part.type2 .kread-detail__table,
    .reading-report .report__section .kread-detail__part.type3 .kread-detail__table {
        width: 100%;
        margin-top: 25px;
        border-bottom: 1px solid #222;
    }
    .reading-report .report__section .kread-detail__part.type2 .kread-detail__table thead,
    .reading-report .report__section .kread-detail__part.type3 .kread-detail__table thead {
        border-top: 1px solid #222;
    }
    .reading-report .report__section .kread-detail__part.type2 .kread-detail__table tbody + tbody tr:first-of-type,
    .reading-report .report__section .kread-detail__part.type3 .kread-detail__table tbody + tbody tr:first-of-type {
        border-top: 1px solid #222;
    }
    .reading-report .report__section .kread-detail__part.type2 .kread-detail__table tbody + tbody tr:last-of-type,
    .reading-report .report__section .kread-detail__part.type3 .kread-detail__table tbody + tbody tr:last-of-type {
        border-bottom: 1px solid #222;
    }
    .reading-report .report__section .kread-detail__part.type2 .kread-detail__table tr,
    .reading-report .report__section .kread-detail__part.type3 .kread-detail__table tr {
        width: 100%;
    }
    .reading-report .report__section .kread-detail__part.type2 .kread-detail__table tr + tr,
    .reading-report .report__section .kread-detail__part.type3 .kread-detail__table tr + tr {
        border-top: 1px solid #ddd;
    }
    .reading-report .report__section .kread-detail__part.type2 .kread-detail__table tr.total,
    .reading-report .report__section .kread-detail__part.type3 .kread-detail__table tr.total {
        background-color: #fffbeb;
    }
    .reading-report .report__section .kread-detail__part.type2 .kread-detail__table tr.total td,
    .reading-report .report__section .kread-detail__part.type3 .kread-detail__table tr.total td {
        font-weight: 600;
    }
    .reading-report .report__section .kread-detail__part.type2 .kread-detail__table th,
    .reading-report .report__section .kread-detail__part.type3 .kread-detail__table th {
        padding: 24px 60px;
        background: #fafafa;
        border-bottom: 1px solid #ddd;
        color: #222;
        font-size: 24px;
        font-weight: 600;
        line-height: 32px;
        text-align: center;
    }
    .reading-report .report__section .kread-detail__part.type2 .kread-detail__table td,
    .reading-report .report__section .kread-detail__part.type3 .kread-detail__table td {
        padding: 30px 60px;
        color: #666;
        font-size: 26px;
        font-weight: 400;
        line-height: 150%;
        text-align: center;
    }
    .reading-report .report__section .kread-detail__part.achievement .contents {
        padding-bottom: 0;
    }
    .reading-report .report__section .kread-detail__part.achievement .chart__title {
        display: block;
        margin-top: 40px;
        color: #18b73f;
        font-size: 24px;
        font-weight: 600;
        line-height: 150%; /* 36px */
        text-align: left;
    }
    .reading-report .report__section .kread-detail__part.achievement .line-chart {
        height: 260px;
        margin-top: 26px;
    }
    .reading-report .report__section .kread-detail__part.achievement .column-chart {
        width: calc(100% - 120px);
        height: 245px;
        margin: 13px auto 60px;
    }
    .reading-report .report__section .kread-detail__part.achievement .column-chart__wrap {
        overflow: hidden;
        position: relative;
        width: calc(100% + 120px);
        margin-top: 40px;
        margin-left: -60px;
    }
    .reading-report .report__section .kread-detail__part.achievement .column-chart__wrap:before {
        content: '';
        display: block;
        position: absolute;
        z-index: -1;
        width: 100%;
        height: 100%;
        background-color: #fafafa;
        border-radius: 0 0 16px 16px;
    }
    .reading-report .report__section .kread-detail__part.achievement .column-chart__wrap .chart__title {
        padding-left: 60px;
    }
    .reading-report .report__section .strength .contents {
        height: 600px;
        padding: 60px;
        background-color: #fafafa;
        border: none;
    }
    .reading-report .report__section .strength .contents .column-chart {
        width: 100%;
        height: 100%;
    }
    .reading-report .report__section .emphasis {
        color: #18b73f;
        font-weight: 700;
    }
    .reading-report .btn__move-prev {
        width: 48px;
        height: 48px;
        background: url('@/assets/images/icon/ico_arrow_back.svg') no-repeat center/contain;
        text-indent: -9999rem;
    }
    .reading-report .btn__print {
        position: absolute;
        right: 40px;
        width: 48px;
        height: 48px;
        /* background: url('/assets/images/ico_print.svg') no-repeat center/contain; */
        text-indent: -9999rem;
    }
    .reading-report .btn__view-detail {
        width: 48px;
        height: 48px;
        /* background: url('/assets/images/ico_tip.svg') no-repeat center/contain; */
        text-indent: -9999rem;
    }
    .reading-report .btn__move {
        display: flex;
        width: 396px;
        height: 98px;
        margin: 80px auto 0;
        padding: 15px 34px;
        justify-content: center;
        align-items: center;
        border: 1px solid #222;
        border-radius: 16px;
        font-size: 24px;
        font-weight: 700;
    }
}

.chart-label {
    display: flex;
    justify-content: end;
    margin-top: vw(60);
}

/* .label-color {
    display: flex;
    align-items: center;
    color: $gray_900;
    font-size: vw(14);

    content: '';
    display: inline-block;
    width: vw(12);
    height: vw(4);
    background: #4fb0f6;
    margin-right: vw(8);
    border-radius: vw(50);
} */
</style>
